<template>
  <v-flex class="pl-2 pr-2">
    <v-layout align-start justify-start row class="ml-3 mb-4">
      <v-icon color="primary" style="font-size: 50px;">show_chart</v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2 ml-2"
      >{{$translate('STATISTICS_OF_DIRECT_BOOKING')}}</h2>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs3>
        <v-combobox
          v-model="dateSelected"
          :items="dateOptions"
          :label="$translate('STATISTICS_SELECT_THE_DATES')"
          outline
          return-masked-value
          persistent-hint
          @input="setDate"
        ></v-combobox>
        <v-date-picker
          v-if="!disableDatePicker"
          v-model="datesInPicker"
          @input="setDateForPicker"
          scrollable
          multiple
          no-title
        />
      </v-flex>
      <v-flex v-if="isAccountAdmin" xs3>
        <v-select
          v-model="partnerSelected"
          :items="partnerOptions"
          item-text="PartnerName"
          item-value="PartnerId"
          :label="$translate('STATISTICS_SELECT_THE_PARTNER')"
          outline
          return-object
        ></v-select>
      </v-flex>
      <v-flex xs2>
        <v-btn
          color="primary darken-1"
          :loading="disableBtn"
          round
          @click="getStatisticsOfDirectBookings"
        >{{$translate('GET_STATISTICS')}}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="directBookings-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="directFinance-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="partnersDirectBookings-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs8>
        <canvas id="partnersDirectFinance-chart" devicePixelRatio="10"></canvas>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import _ from "lodash";
import { mapGetters } from "vuex";
import Chart from "chart.js";
import "chartjs-plugin-zoom";

export default {
  name: "Statistics_DirectBookings",
  components: {},
  computed: mapGetters({
    currentAccountId: "getCurrentAccountId",
  }),
  props: ["partnerOptions", "isAccountAdmin", "timeSteps"],
  data() {
    return {
      partnerSelected: {},
      dateSelected: "",
      dateOptions: [
        "Last 7 days",
        "Last 14 days",
        "Last 30 days",
        "Choose date",
      ],
      startDate: "",
      endDate: "",
      datesInPicker: [],
      disableDatePicker: true,
      nrOfPoints: 1,
      disableBtn: false,
      directBookingStatics: {},
      ctx: {},
      directBookingGraph: null,
      financeGraph: null,
      partnersDirectBookingGraph: null,
      partnersFinanceGraph: null,
      graphsData: {
        type: "line",
        data: {
          labels: [],
          datasets: [
            {
              label: "Nr of bookings",
              data: [],
              borderColor: "rgb(255, 0, 0)",
              borderWidth: 3,
              cubicInterpolationMode: "monotone",
            },
            {
              label: "Nr of booking actual visited",
              data: [],
              borderColor: "rgb(0, 255, 0)",
              borderWidth: 3,
              cubicInterpolationMode: "monotone",
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Direct Bookings",
            fontSize: 20,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 9,
                  display: true,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  callback: function (value, index, values) {
                    return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 100,
                },
              },
            ],
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "x",
              },
              zoom: {
                enabled: true,
                mode: "x",
              },
            },
          },
        },
      },
      financeGraphData: {
        type: "line",
        data: {
          labels: [],
          datasets: [
            {
              label: "Amount of money earned via direct bookings",
              data: [],
              borderColor: "rgb(255, 0, 0)",
              borderWidth: 3,
              cubicInterpolationMode: "monotone",
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Finance",
            fontSize: 20,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 9,
                  display: true,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  callback: function (value, index, values) {
                    return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 100,
                },
              },
            ],
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "x",
              },
              zoom: {
                enabled: true,
                mode: "x",
              },
            },
          },
        },
      },
      // Direct bookings grouped by partners
      partnersDirectBookingsData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "Nr of bookings",
              data: [],
              borderColor: "rgb(255, 0, 0)",
              backgroundColor: "rgb(255, 0, 0)",
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
            {
              label: "Nr of booking actual visited",
              data: [],
              borderColor: "rgb(0, 255, 0)",
              backgroundColor: "rgb(0, 255, 0)",
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Direct Bookings Per Partner",
            fontSize: 20,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 9,
                  display: true,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  callback: function (value, index, values) {
                    return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 100,
                },
              },
            ],
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "x",
              },
              zoom: {
                enabled: true,
                mode: "x",
              },
            },
          },
        },
      },
      // Finance graph grouped by partners
      partnersFinanceGraphData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "Amount of money earned via direct bookings",
              data: [],
              borderColor: "rgb(255, 0, 0)",
              backgroundColor: "rgb(255, 0, 0)",
              borderWidth: 3,
              barThickness: "flex",
              lineTension: 0,
            },
          ],
        },
        options: {
          responsive: true,
          title: {
            display: true,
            text: "Statistics of Finance Per Partner",
            fontSize: 20,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontSize: 9,
                  display: true,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  callback: function (value, index, values) {
                    return value;
                  },
                  display: true,
                  beginAtZero: true,
                  stepSize: 100,
                },
              },
            ],
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "x",
              },
              zoom: {
                enabled: true,
                mode: "x",
              },
            },
          },
        },
      },
    };
  },

  mounted() {
    this.dateSelected = this.dateOptions[0];
    this.partnerSelected = this.partnerOptions[0];

    this.setDate();
    this.createGraphs();
    this.getStatisticsOfDirectBookings();
  },

  methods: {
    getLabels() {
      if (this.startDate === this.endDate) {
        // Divide the day into different sections with timeSteps
        this.nrOfPoints = Number(this.timeSteps);
        for (let i = 0; i < this.nrOfPoints; i++) {
          this.graphsData.data.labels.push(i.toString());
          this.financeGraphData.data.labels.push(i.toString());
        }
      } else {
        const [dayStart, monthStart, yearStart] = this.startDate.split("-");
        const [dayEnd, monthEnd, yearEnd] = this.endDate.split("-");
        let tmpStartDate = new Date(yearStart, monthStart - 1, dayStart);
        let tmpEndDate = new Date(yearEnd, monthEnd - 1, dayEnd);
        this.nrOfPoints =
          Math.round((tmpEndDate.getTime() - tmpStartDate.getTime()) / 86400000 + 1);

        let tmpDate = new Date();
        let tmpDateFormatted = "";

        for (let i = 0; i < this.nrOfPoints; i++) {
          tmpDate.setTime(tmpStartDate.getTime() + i * 86400000);
          tmpDateFormatted =
            ("0" + tmpDate.getDate()).slice(-2) +
            "-" +
            ("0" + (tmpDate.getMonth() + 1)).slice(-2) +
            "-" +
            tmpDate.getFullYear();
          this.graphsData.data.labels.push(tmpDateFormatted);
          this.financeGraphData.data.labels.push(tmpDateFormatted);
        }
      }
    },

    translateLabels() {
      // When start date equals to end date, the label should be translated to time sections
      this.graphsData.data.labels = [];
      this.financeGraphData.data.labels = [];
      let newLabel = "";
      let timeLength = 24 / this.nrOfPoints;
      for (let i = 0; i < this.nrOfPoints; i++) {
        newLabel = `${i * timeLength} - ${(i + 1) * timeLength} Hours`;
        this.graphsData.data.labels.push(newLabel);
        this.financeGraphData.data.labels.push(newLabel);
      }
    },

    setDate() {
      if (this.dateSelected === this.dateOptions[3]) {
        this.startDate = "";
        this.endDate = "";
        this.datesInPicker = [];
        this.disableDatePicker = false;
        this.dateSelected = "Choose start date";
      } else {
        let tmpDate = new Date();
        this.endDate =
          ("0" + tmpDate.getDate()).slice(-2) +
          "-" +
          ("0" + (tmpDate.getMonth() + 1)).slice(-2) +
          "-" +
          tmpDate.getFullYear();
        if (this.dateSelected === this.dateOptions[0]) this.nrOfPoints = 7;
        else if (this.dateSelected === this.dateOptions[1])
          this.nrOfPoints = 14;
        else if (this.dateSelected === this.dateOptions[2])
          this.nrOfPoints = 30;

        this.startDate = this.getStartDate(this.endDate, this.nrOfPoints);
      }
    },

    setDateForPicker() {
      if (this.datesInPicker.length == 0) {
        if (this.startDate === "") {
          this.dateSelected = "-";
          return;
        } else {
          this.endDate = this.startDate;
          this.dateSelected = this.startDate + " - " + this.endDate;

          // Close the date picker
          this.disableDatePicker = true;
        }
      } else if (this.datesInPicker.length == 1) {
        // Get start date
        const [yearStart, monthStart, dayStart] = this.datesInPicker[0].split(
          "-"
        );
        this.startDate = `${dayStart}-${monthStart}-${yearStart}`;

        this.dateSelected = this.startDate + " - ";
      } else if (this.datesInPicker.length == 2) {
        // Get end date
        const [yearEnd, monthEnd, dayEnd] = this.datesInPicker[1].split("-");
        this.endDate = `${dayEnd}-${monthEnd}-${yearEnd}`;

        this.dateSelected = this.startDate + " - " + this.endDate;

        // Close the date picker
        this.disableDatePicker = true;
      } else {
        // Close the date picker
        this.disableDatePicker = true;
      }
    },

    getStartDate(endDate, nrOfPoints) {
      // Format of date: dd-mm-yyyy
      const [dayEnd, monthEnd, yearEnd] = endDate.split("-");
      let tmpDate = new Date(yearEnd, monthEnd - 1, dayEnd);
      tmpDate.setTime(tmpDate.getTime() - (nrOfPoints - 1) * 86400000);
      return (
        ("0" + tmpDate.getDate()).slice(-2) +
        "-" +
        ("0" + (tmpDate.getMonth() + 1)).slice(-2) +
        "-" +
        tmpDate.getFullYear()
      );
    },

    createGraphs() {
      this.ctx = document.getElementById("directBookings-chart");

      // Update labels of the graph
      this.graphsData.data.labels = [];
      this.financeGraphData.data.labels = [];
      this.getLabels();

      // Initialize each data in data sets with 0
      this.graphsData.data.datasets.forEach((element) => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      this.financeGraphData.data.datasets.forEach((element) => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      if (this.startDate == this.endDate) this.translateLabels();

      if (this.directBookingGraph) this.directBookingGraph.destroy();
      this.directBookingGraph = new Chart(this.ctx, this.graphsData);

      if (this.financeGraph) this.financeGraph.destroy();
      this.ctx = document.getElementById("directFinance-chart");
      this.financeGraph = new Chart(this.ctx, this.financeGraphData);

      // Direct bookings grouped by partner
      this.partnersDirectBookingsData.data.labels = [];
      this.partnersDirectBookingsData.data.datasets[0].data = [];
      this.partnersDirectBookingsData.data.datasets[1].data = [];
      if (this.partnersDirectBookingGraph)
        this.partnersDirectBookingGraph.destroy();
      this.ctx = document.getElementById("partnersDirectBookings-chart");
      this.partnersDirectBookingGraph = new Chart(
        this.ctx,
        this.partnersDirectBookingsData
      );

      // Finance grouped by partner
      this.partnersFinanceGraphData.data.labels = [];
      this.partnersFinanceGraphData.data.datasets[0].data = [];
      if (this.partnersFinanceGraph) this.partnersFinanceGraph.destroy();
      this.ctx = document.getElementById("partnersDirectFinance-chart");
      this.partnersFinanceGraph = new Chart(
        this.ctx,
        this.partnersFinanceGraphData
      );
    },

    updateGraphs() {
      // Update labels of the graph
      this.graphsData.data.labels = [];
      this.financeGraphData.data.labels = [];
      this.getLabels();

      // Initialize each data in data sets with 0
      this.graphsData.data.datasets.forEach((element) => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      this.financeGraphData.data.datasets.forEach((element) => {
        element.data = Array(Math.round(this.nrOfPoints)).fill(0);
      });

      // Update data of direct booking total
      for (let [k, v] of Object.entries(this.directBookingStatics.Booked)) {
        let itemIndex = this.graphsData.data.labels.indexOf(k);
        if (itemIndex !== -1) {
          // Get the corresponding index of the date in the array of labels
          this.graphsData.data.datasets[0].data[itemIndex] = Number(v);
        }
      }

      // Update data of direct booking visited
      for (let [k, v] of Object.entries(this.directBookingStatics.Visited)) {
        let itemIndex = this.graphsData.data.labels.indexOf(k);
        if (itemIndex !== -1) {
          // Get the corresponding index of the date in the array of labels
          this.graphsData.data.datasets[1].data[itemIndex] = Number(v);
        }
      }

      // Update data of finance
      for (let [k, v] of Object.entries(this.directBookingStatics.Financial)) {
        let itemIndex = this.financeGraphData.data.labels.indexOf(k);
        if (itemIndex !== -1) {
          // Get the corresponding index of the date in the array of labels
          this.financeGraphData.data.datasets[0].data[itemIndex] = Number(v);
        }
      }

      if (this.directBookingStatics.hasOwnProperty("PartnersBooked")) {
        // Update partners direct bookings data, then update graph
        this.updatePartnersBookingGraphData(
          this.directBookingStatics.PartnersBooked,
          this.directBookingStatics.PartnersVisited
        );
        this.partnersDirectBookingGraph.update();
      }

      if (this.directBookingStatics.hasOwnProperty("PartnersFinancial")) {
        // Update partners finance data, then update graph
        this.updatePartnersFinanceGraphData(
          this.directBookingStatics.PartnersFinancial
        );
        this.partnersFinanceGraph.update();
      }

      if (this.startDate == this.endDate) this.translateLabels();

      this.directBookingGraph.update();
      this.financeGraph.update();
    },

    getStatisticsOfDirectBookings() {
      this.disableBtn = true;

      // Action for loading all the Partners in the current account
      const payload = {
        StartDate: this.startDate,
        EndDate: this.endDate,
        FunctionId: "EventFunctionLibrary::getDirectStats",
      };

      if (this.partnerSelected.PartnerId > 0)
        payload.PartnerId = this.partnerSelected.PartnerId;
      if (this.startDate === this.endDate) payload.TimeSteps = this.timeSteps;

      dssRequest.doRequest(
        (response) => {
          console.log("the call for getDirectStats was successful", response);
          this.directBookingStatics = Object.assign({}, response.data.Direct);
          this.updateGraphs();
          this.disableBtn = false;
        },
        (error) => {
          console.log("the call for getDirectStats was not successful", error);
          this.disableBtn = false;
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },

    updatePartnersBookingGraphData(partnersBookings, partnersVisited) {
      // Empty graph data before update
      this.partnersDirectBookingsData.data.labels = [];
      this.partnersDirectBookingsData.data.datasets[0].data = [];
      this.partnersDirectBookingsData.data.datasets[1].data = [];

      // Merge partnersBookings and partnersVisited
      let bokingAndVisitedAll = partnersBookings.concat(partnersVisited);
      let bokingAndVisitedUnique = [];

      for(var i = 0; i < bokingAndVisitedAll.length; i++)
      {
        let idSearch = bokingAndVisitedUnique.find((obj) => Number(obj.PartnerId) === Number(bokingAndVisitedAll[i].PartnerId));
        if(idSearch != null)
          continue;

        let tmpObj = {PartnerId: bokingAndVisitedAll[i].PartnerId};

        let bookingSearch = partnersBookings.find((obj) => Number(obj.PartnerId) === Number(bokingAndVisitedAll[i].PartnerId));
        if(bookingSearch != null)
          tmpObj.Booked = bookingSearch.Booked;
        else
          tmpObj.Booked = 0;
        
        let visitedSearch = partnersVisited.find((obj) => Number(obj.PartnerId) === Number(bokingAndVisitedAll[i].PartnerId));
        if(visitedSearch != null)
          tmpObj.Visited = visitedSearch.Visited;
        else
          tmpObj.Visited =  0;

        bokingAndVisitedUnique.push(tmpObj);
      }
      
      // Update graph data with new one
      bokingAndVisitedUnique.forEach((obj) => {
        let partner = this.partnerOptions.find(
          (partnerObj) =>
            Number(partnerObj.PartnerId) === Number(obj.PartnerId)
        );
        this.partnersDirectBookingsData.data.labels.push(partner.PartnerName);
        this.partnersDirectBookingsData.data.datasets[0].data.push(
          obj.Booked
        );
        this.partnersDirectBookingsData.data.datasets[1].data.push(
          obj.Visited
        );
      });
    },

    updatePartnersFinanceGraphData(partnersFinances) {
      // Empty graph data before update
      this.partnersFinanceGraphData.data.labels = [];
      this.partnersFinanceGraphData.data.datasets[0].data = [];
      if (partnersFinances != null && partnersFinances.length > 0) {
        // Update graph data with new one
        partnersFinances.forEach((finance) => {
          const partner = this.partnerOptions.find(
            (partnerObj) =>
              Number(partnerObj.PartnerId) === Number(finance.PartnerId)
          );
          this.partnersFinanceGraphData.data.labels.push(partner.PartnerName);
          this.partnersFinanceGraphData.data.datasets[0].data.push(
            finance.Financial
          );
        });
      }
    },
  },
};
</script>

<style lang="scss", scoped>
.center_table > td {
  text-align: center;
}
</style>
